import React from 'react';

export const generateBlankProxyForm = (hoaName, electionName, meetingDate) => {
  const printWindow = window.open('', '_blank');
  
  const formHTML = `
    <!DOCTYPE html>
    <html>
    <head>
      <title>Proxy Form - ${hoaName}</title>
      <style>
        body { 
          font-family: 'Times New Roman', Times, serif;
          max-width: 8.5in;
          margin: 0 auto;
          padding: 0.5in;
          background: white;
          line-height: 1.6;
        }
        .header {
          text-align: center;
          margin-bottom: 30px;
        }
        .hoa-name {
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 5px;
        }
        .form-title {
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 20px;
        }
        .section {
          margin-bottom: 25px;
        }
        .section-title {
          font-weight: bold;
          margin-bottom: 10px;
        }
        .field {
          margin-bottom: 15px;
        }
        .field-label {
          display: block;
          margin-bottom: 5px;
        }
        .field-line {
          border-bottom: 1px solid #000;
          min-height: 20px;
          width: 100%;
          display: inline-block;
        }
        .checkbox-group {
          margin: 10px 0;
        }
        .checkbox-item {
          display: flex;
          align-items: flex-start;
          margin-bottom: 8px;
        }
        .checkbox {
          width: 18px;
          height: 18px;
          border: 2px solid #000;
          margin-right: 10px;
          flex-shrink: 0;
          margin-top: 2px;
        }
        .signature-section {
          margin-top: 40px;
        }
        .signature-line {
          border-bottom: 1px solid #000;
          width: 300px;
          display: inline-block;
          margin-right: 20px;
        }
        .small-text {
          font-size: 11px;
          line-height: 1.4;
        }
        .page-break {
          page-break-after: always;
        }
        @media print {
          body { padding: 0.5in; }
          .no-print { display: none; }
        }
      </style>
    </head>
    <body>
      <div class="header">
        <div class="hoa-name">${hoaName.toUpperCase()}</div>
        <div class="form-title">PROXY FORM</div>
      </div>

      <div class="section">
        <div class="section-title">1. MEMBER INFORMATION (Originator)</div>
        <div class="field">
          <span class="field-label">Name of Owner:</span>
          <span class="field-line"></span>
        </div>
        <div class="field">
          <span class="field-label">Property Identifier (lot / parcel / address):</span>
          <span class="field-line"></span>
        </div>
      </div>

      <div class="section">
        <div class="section-title">2. TYPE OF PROXY (check one)</div>
        <div class="checkbox-group">
          <div class="checkbox-item">
            <div class="checkbox"></div>
            <div>
              <strong>GENERAL PROXY</strong> – I authorize the proxy holder named below to vote on all matters at the meeting.
            </div>
          </div>
          <div class="checkbox-item">
            <div class="checkbox"></div>
            <div>
              <strong>LIMITED PROXY</strong> – I authorize the proxy holder named below to vote only on the specific item(s) listed in Section 3.
            </div>
          </div>
        </div>
      </div>

      <div class="section">
        <div class="section-title">3. LIMITED PROXY – SPECIFIC MOTION(S)</div>
        <div class="field">
          <span class="field-label">Motion/Issue Description:</span>
          <span class="field-line"></span>
        </div>
        <div class="field" style="margin-top: 15px;">
          <span class="field-label">Your Vote (check one):</span>
          <div class="checkbox-group">
            <div class="checkbox-item">
              <div class="checkbox"></div>
              <div>YES (FOR)</div>
            </div>
            <div class="checkbox-item">
              <div class="checkbox"></div>
              <div>NO (AGAINST)</div>
            </div>
            <div class="checkbox-item">
              <div class="checkbox"></div>
              <div>DELEGATE DISCRETION</div>
            </div>
            <div class="checkbox-item">
              <div class="checkbox"></div>
              <div>OTHER (specify): <span class="field-line" style="width: 200px;"></span></div>
            </div>
          </div>
        </div>
      </div>

      <div class="section">
        <div class="section-title">4. PROXY HOLDER</div>
        <div class="field">
          <span class="field-label">Name of Proxy Holder:</span>
          <span class="field-line"></span>
        </div>
      </div>

      <div class="section">
        <div class="section-title">5. MEETING DETAILS</div>
        <div class="field">
          <span class="field-label">Election/Meeting: <strong>${electionName}</strong></span>
        </div>
        <div class="field">
          <span class="field-label">Date of Meeting: <strong>${meetingDate}</strong></span>
        </div>
        <div class="field">
          <span class="field-label">Time (if known):</span>
          <span class="field-line" style="width: 200px;"></span>
        </div>
      </div>

      <div class="signature-section">
        <div class="section-title">6. SIGNATURE OF OWNER (Originator)</div>
        <div class="field">
          <span class="field-label">Owner Signature:</span>
          <span class="field-line" style="width: 400px;"></span>
        </div>
        <div class="field" style="margin-top: 20px;">
          <span class="field-label">Print Name:</span>
          <span class="field-line" style="width: 300px;"></span>
          <span style="margin-left: 30px;">Date:</span>
          <span class="field-line" style="width: 150px;"></span>
        </div>
      </div>

      <div class="section" style="margin-top: 30px;">
        <div class="field">
          <span class="field-label"><em>Optional Acknowledgment by Proxy Holder (not required by law):</em></span>
        </div>
        <div class="field">
          <span class="field-label">Proxy Holder Signature (optional):</span>
          <span class="field-line" style="width: 300px;"></span>
          <span style="margin-left: 20px;">Date:</span>
          <span class="field-line" style="width: 150px;"></span>
        </div>
      </div>

      <div class="section" style="margin-top: 30px; padding-top: 20px; border-top: 1px solid #ccc;">
        <div class="small-text">
          <strong>Revocation:</strong> This proxy may be revoked by the owner at any time prior to its exercise.
        </div>
        <div class="small-text" style="margin-top: 10px;">
          <strong>Return Instructions:</strong> May be returned by mail, email, portal upload, or in person.
        </div>
      </div>

      <div class="page-break"></div>

      <div class="small-text" style="margin-top: 30px; padding: 15px; background: #f5f5f5; border: 1px solid #ddd;">
        <strong>Example State Law Guidance (for reference):</strong><br><br>
        
        <strong>Florida</strong> (FS §720.306(8)): Proxies are valid only for the meeting for which given and any lawful adjournment thereof, and expire 90 days from the date of that meeting.<br><br>
        
        <strong>Texas</strong> (Tex. Bus. Org. Code §22.160): Proxies may remain valid for up to 11 months unless a shorter period is stated in the instrument.<br><br>
        
        <strong>Arizona</strong> (A.R.S. §33-1812): Proxies are valid only for the specific meeting identified and expire upon adjournment.<br><br>
        
        <strong>Colorado</strong> (CRS §7-127-203): Generally limits proxy authority to the designated meeting unless otherwise provided by governing documents.<br><br>
        
        <strong>California Condos</strong> (Davis-Stirling Act, Cal. Civ. Code §5100-5145): Prohibit the use of proxies for member elections, requiring mailed or electronic ballots instead.<br><br>
        
        <em>Note: Always consult your state's current laws and your HOA's governing documents for specific proxy requirements.</em>
      </div>

      <div class="no-print" style="text-align: center; margin-top: 30px;">
        <button onclick="window.print()" style="padding: 12px 24px; font-size: 16px; background: #3b82f6; color: white; border: none; border-radius: 8px; cursor: pointer; margin-right: 10px;">Print Form</button>
        <button onclick="window.close()" style="padding: 12px 24px; font-size: 16px; background: #6b7280; color: white; border: none; border-radius: 8px; cursor: pointer;">Close</button>
      </div>
    </body>
    </html>
  `;
  
  printWindow.document.write(formHTML);
  printWindow.document.close();
};

export default generateBlankProxyForm;
